module.exports = __webpack_public_path__ + "img/downhill-skiing.f5b67ea3.svg";